import { z } from 'zod';
import type { TFunction } from 'i18next';

export function createFeedbackSchema(t: TFunction) {
  return z
    .object({
      category: z.enum(['Bug', 'Suggestion', 'GeneralExperience']),
      liked: z.string().optional(),
      improvements: z.string().optional(),
      comments: z.string().optional(),
    })
    .refine(
      (data) =>
        (data.liked && data.liked.trim().length > 0) ||
        (data.improvements && data.improvements.trim().length > 0) ||
        (data.comments && data.comments.trim().length > 0),
      { message: t('feedback.validation'), path: ['comments'] },
    );
}

export type FeedbackFormValues = z.infer<ReturnType<typeof createFeedbackSchema>>;
